import axios from "axios";
import Config from "src/config";

const v2_actionGetSentimentAnalysis = (chatId) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/ai/${chatId}/sentiment-analysis`,
    });
};

export default v2_actionGetSentimentAnalysis; 